// extracted by mini-css-extract-plugin
export default {"icon":"HeaderSettingsButton_icon__jGXp4","badge":"HeaderSettingsButton_badge__LLg+e","bump":"HeaderSettingsButton_bump__rUXOp"};